// Web feature list (warehouse management system - web users)
export const AVAILABLE_FEATURES = {
  locations: { label: 'LOCATIONS', category: 'WAREHOUSE' },
  bins: { label: 'BINS', category: 'WAREHOUSE' },
  inventory: { label: 'INVENTORY', category: 'WAREHOUSE' },
  items: { label: 'ITEMS', category: 'WAREHOUSE' },
  salesorder: { label: 'SALES ORDER', category: 'ORDERS' },
  dropshipSalesOrders: { label: 'DROPSHIP SALES ORDERS', category: 'ORDERS' },
  salesOrderList: { label: 'SALES ORDER LIST', category: 'ORDERS' },
  inbound: { label: 'INBOUND', category: 'ORDERS' },
  bincount: { label: 'BIN COUNT', category: 'INVENTORY MANAGEMENT' },
  binAdjustment: { label: 'BIN ADJUSTMENT', category: 'INVENTORY MANAGEMENT' },
  binTransfer: { label: 'BIN TRANSFER', category: 'TRANSFER' },
  homedepotProductsErrors: { label: 'HOME DEPOT PRODUCTS ERRORS', category: 'ERRORS' },
  shippingLabelErrors: { label: 'SHIPPING LABEL ERRORS', category: 'ERRORS' },
  masterScraperData: { label: 'ALL SCRAPER ITEM DATA', category: 'SCRAPER DATA' },
  ltlDashboard: { label: 'LTL DASHBOARD', category: 'DASHBOARD' },
  ltlPickProgress: { label: 'LTL PICK PROGRESS', category: 'DASHBOARD' },
  regularPickProgress: { label: 'REGULAR PICK PROGRESS', category: 'DASHBOARD' },
  fedexShippingAnalysis: { label: 'FEDEX SHIPPING ANALYSIS', category: 'ANALYTICS' },
  marketPlacePrice: { label: 'MARKETPLACE PRICE', category: 'ANALYTICS' },
  itemSalesByCus: { label: 'ITEM SALES BY CUSTOMER', category: 'ANALYTICS' },
  ltlInsufficientInventory: { label: 'LTL INSUFFICIENT INVENTORY', category: 'ANALYTICS' },
  regularDashboard: { label: 'REGULAR DASHBOARD', category: 'DASHBOARD' },
  amAmxlDashboard: { label: 'AMAZON AMXL DASHBOARD', category: 'DASHBOARD' },
  amAtsDashboard: { label: 'ATS DASHBOARD', category: 'DASHBOARD' },
  userPickStatus: { label: 'USER PICK STATUS', category: 'DASHBOARD' },
  PartsDashboard: { label: 'PARTS DASHBOARD', category: 'DASHBOARD' },
  UpdateMarketplacePricing: { label: 'UPDATE MARKETPLACE PRICING', category: 'PRICING' },
};

// Mobile feature list (mobile app users)
// Add or update mobile-specific features here as the mobile app evolves
export const MOBILE_FEATURES = {
  itemLookup: { label: 'ITEM LOOKUP', category: 'ITEM LOOKUP' },
  binCount: { label: 'BIN COUNT', category: 'INVENTORY' },
  binAdjustments: { label: 'BIN ADJUSTMENT', category: 'INVENTORY' },
  binTransfer: { label: 'BIN TRANSFER', category: 'TRANSFER' },
  ftzBinTransfer: { label: 'FTZ - BIN TRANSFER', category: 'TRANSFER' },
  uncountedBins: { label: 'UNCOUNTED BINS', category: 'INVENTORY' },
  ltlOrders: { label: 'LTL PICKING', category: 'PICKING' },
  dropShip: { label: 'REGULAR PICKING', category: 'PICKING' },
  partsPicking: { label: 'PARTS PICKING', category: 'PICKING' },
  shipConfirm: { label: 'SHIP CONFIRM', category: 'PICKING' },
  rma: { label: 'RMA RETURN', category: 'PICKING' },
  regularReprint: { label: 'REGULAR REPRINT', category: 'PICKING' },
  foldingStationLabels: { label: 'FOLDING STATION LABELS', category: 'PICKING' },
  reassignLtlOrders: { label: 'REASSIGN LTL ORDERS', category: 'REASSIGN ORDER' },
  dropshipReassign: { label: 'REASSIGN REGULAR ORDERS', category: 'REASSIGN ORDER' },
  inbound: { label: 'INBOUND SHIPMENT', category: 'RECEIVING' },
  ftzInbound: { label: 'FTZ - INBOUND', category: 'RECEIVING' },
  ltlDashboard: { label: 'LTL DASHBOARD', category: 'DASHBOARD ORDER' },
  amAmxlDashboard: { label: 'AMAZON AMXL DASHBOARD', category: 'DASHBOARD ORDER' },
  amAtsDashboard: { label: 'ATS DASHBOARD', category: 'DASHBOARD ORDER' },
  amUpsDashboard: { label: 'UPS DASHBOARD', category: 'DASHBOARD ORDER' },
  shipConfirmAudit: { label: 'SHIP CONFIRM AUDIT', category: 'TRACKING STATUS' },
  noShipconfirmReport: { label: 'NO SHIP CONFIRM REPORT', category: 'TRACKING STATUS' },
  binCountReports: { label: 'BIN COUNT RECORDS', category: 'REPORTS' },
  binTransactions: { label: 'BIN TRANSACTIONS', category: 'REPORTS' },
  inboundReports: { label: 'INBOUND SHIPMENT RECORDS', category: 'REPORTS' },
  binTransferReports: { label: 'BIN TRANSFER RECORDS', category: 'REPORTS' },
  managerOtp: { label: 'MANAGER OTP', category: 'REPORTS' },
  binTransferUserReport: { label: 'BIN TRANSFER USER REPORT', category: 'REPORTS' },
  binAdjustmentsReport: { label: 'BIN ADJUSTMENT RECORDS', category: 'REPORTS' },
  userPickedReport: { label: 'USER PICKED REPORT', category: 'REPORTS' },
  userSkipReport: { label: 'USER SKIP REPORT', category: 'REPORTS' },
  inventoryManagerApproval: { label: 'INVENTORY MANAGER APPROVAL', category: 'ALL REPORTS (REPORTS TAB)' },
  itemLevelActivity: { label: 'ITEM LEVEL ACTIVITY', category: 'REPORTS' },
  ftzQrGenerate: { label: 'FTZ QR GENERATE', category: 'FTZ' },
  ftzPicking: { label: 'FTZ PICKING', category: 'FTZ' },
};

// Get feature map by platform
export const getFeaturesByPlatform = (platform) =>
  platform === 'mobile' ? MOBILE_FEATURES : AVAILABLE_FEATURES;

// Get default features object with all false
export const getDefaultFeatures = (platform) => {
  const featureMap = getFeaturesByPlatform(platform);
  const defaults = {};
  Object.keys(featureMap).forEach(key => {
    defaults[key] = false;
  });
  return defaults;
};

// Get features grouped by category
export const getFeaturesGroupedByCategory = (platform) => {
  const featureMap = getFeaturesByPlatform(platform);
  const grouped = {};
  Object.entries(featureMap).forEach(([key, value]) => {
    if (!grouped[value.category]) {
      grouped[value.category] = [];
    }
    grouped[value.category].push({ key, label: value.label });
  });
  return grouped;
};
